import { LABELS } from '../../lib/u99';

export const Label = ({ id, size = 'sm', className = '' }) => {
  const meta = LABELS[id] || LABELS.reference;
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border font-mono-precision uppercase tracking-[0.2em] ${size === 'xs' ? 'text-[9px] px-2.5 py-0.5' : 'text-[10px] px-3 py-1'} ${className}`}
      style={{ color: meta.color, borderColor: `${meta.color}55`, background: `${meta.color}0d` }}
      data-testid={`label-${id}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.name}
    </span>
  );
};

export const LabelLegend = () => (
  <div className="grid sm:grid-cols-3 gap-4" data-testid="label-legend">
    {['creative-doctrine', 'psychological-guidance', 'scientific-hypothesis'].map((id) => (
      <div key={id} className="rounded-2xl border border-white/[0.07] p-5">
        <Label id={id} />
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">{LABELS[id].desc}</p>
      </div>
    ))}
  </div>
);
